import { create } from 'zustand';
import apiClient from '../api/api';
import { API_ENDPOINTS } from '../endpoints';
import { toast } from 'react-toastify';

const useUserManagementStore = create((set) => ({
  users: [],
  loading: false,
  error: null,
  page: 0,
  rowsPerPage: 10,
  searchTerm: '',
  sortByRank: '',
  filterByActive: '',

  setPage: (page) => set({ page }),
  setRowsPerPage: (rowsPerPage) => set({ rowsPerPage }),
  setSearchTermState: (searchTerm) => set({ searchTerm }),
  setSortByRank: (sortByRank) => set({ sortByRank }),
  setFilterByActive: (filterByActive) => set({ filterByActive }),

  searchUsers: async (searchTerm = '') => {
    const trimmed = (searchTerm || '').trim();
    if (trimmed && trimmed.length < 3) {
      set({ users: [], loading: false, error: null });
      return;
    }
    try {
      set({ loading: true, error: null });
      const response = await apiClient.post(API_ENDPOINTS.searchUsers, {
        userName: trimmed,
      });
      const data = Array.isArray(response.data) ? response.data : [];
      set({ users: data, loading: false });
    } catch (error) {
      console.error("Failed to search users", error);
      set({ error: 'Failed to search users.', loading: false, users: [] });
    }
  },

  deleteUser: async (userId, successMessage) => {
    try {
      set({ loading: true, error: null });
      await apiClient.delete(`/rs/deleteUserAndData/${userId}`);
      set((state) => ({
        users: state.users.filter((user) => user.id !== userId),
        loading: false,
      }));
      toast.success(successMessage || 'User deleted successfully');
    } catch (error) {
      console.error("Failed to delete user", error);
      set({ error: 'Failed to delete user.', loading: false });
      throw error;
    }
  },
}));

export default useUserManagementStore;
